import queryString from "query-string";
import callGraphQL from "@lululemon/ecom-cdp/src/graphql/callGraphQL";
import { createSearchQuery } from "@lululemon/ecom-cdp/src/graphql/graphql-utils";
import { sanitize } from "@lululemon/ecom-common/src/lib/util";

const getURLEncoded = (value) => {
  if (typeof value !== "string" || value.indexOf("%") > -1) {
    return value;
  }
  return encodeURIComponent(value);
};

const fetchSearchResults = async (
  graphqlClient,
  searchNavigationUrl,
  pagingParams,
  { locale, genderAffinity, fusionExperimentVariant = null }
) => {
  const arr = searchNavigationUrl.split("?");
  const parsedQs = queryString.parse(arr[1]);

  const terms = sanitize(parsedQs.Ntt);
  const pageOffset =
    pagingParams.page > 1 ? (pagingParams.page - 1) * pagingParams.pageSize : 0;
  const pageLimit = pagingParams.pageSize || null;

  let filters = [];
  if (parsedQs.filters) {
    if (Array.isArray(parsedQs.filters)) {
      filters = parsedQs.filters.map((filter) => getURLEncoded(filter));
    } else {
      filters = [getURLEncoded(parsedQs.filters)];
    }
  }
  // OTHER PARAMS
  const { type = null, sort = null } = parsedQs;

  const params = {
    terms,
    locale,
    genderAffinity,
    filters,
    pageLimit,
    pageOffset,
    sort,
    type,
    fusionExperimentVariant,
  };

  const graphQuery = createSearchQuery();
  const { data } = await callGraphQL({
    graphQuery,
    params,
    utilTitle: "ecom-search/fetchSearchResults",
    graphqlClient,
    resolverName: "searchResults",
    errorHandler: (error) => {
      throw error;
    },
  });

  if (data?.search) {
    return {
      data: JSON.parse(data.search),
    };
  }

  return {
    data: null,
  };
};

export default fetchSearchResults;
